module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/vi_shikoku-44fd4ecaadd5ff3d2cf73a0c00b17f7f.jpg";